function e(e){return e?(e.nodeName||"").toLowerCase():null}export{e as default};
//# sourceMappingURL=getNodeName.js.map
